import { ColumnType } from "antd/lib/table";
import { formatarDataBR } from "../../ModalPlanejamentoOperacoes/ModalAnteciparOuProrrogar/utils";

const columns = (): ColumnType<any>[] => {

  let columnsShow: ColumnType<any>[] = [
    {
      title: "Motivo",
      dataIndex: "tipoAtraso",
      align: "center",
      width: 20,
      render: (value: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {value}
          </span>
        )
      },
    },
    {
      title: "Descrição",
      dataIndex: "justificativa",
      align: "center",
      width: 35,
      render: (value: string) => <span style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Data",
      dataIndex: "data",
      align: "center",
      width: 35,
      render: (value: string) => <span style={{ fontSize: 13 }}>{formatarDataBR(value, true) ?? "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: "aprovado",
      align: "center",
      width: 35,
      render: (value: string) => <span style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
  ];

  return columnsShow;
}
export default columns;
